import React from 'react';

const PageNotFound = (props) => {
    return (<>
        <br/><br/>
        <h2>Page not found</h2>
        <p>Please choose another page from the navigation menu.</p>
    </>)
}

export default PageNotFound;
